import { ConfirmationType } from '../components/ConfirmationModal';

export interface ConfirmationOptions {
  title: string;
  message: string;
  type?: ConfirmationType;
  confirmText?: string;
  cancelText?: string;
  showCancelButton?: boolean;
  confirmButtonColor?: 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

// Common confirmation presets
export const confirmations = {
  delete: (itemName: string): ConfirmationOptions => ({
    title: 'Confirmer la suppression',
    message: `Êtes-vous sûr de vouloir supprimer "${itemName}" ? Cette action ne peut pas être annulée.`,
    type: 'warning',
    confirmText: 'Supprimer',
    cancelText: 'Annuler',
    confirmButtonColor: 'error',
  }),

  clear: (itemType: string): ConfirmationOptions => ({
    title: `Vider ${itemType}`,
    message: `Êtes-vous sûr de vouloir vider complètement ${itemType} ? Cette action ne peut pas être annulée.`,
    type: 'warning',
    confirmText: `Vider ${itemType}`,
    cancelText: 'Annuler',
    confirmButtonColor: 'error',
  }),

  logout: (): ConfirmationOptions => ({
    title: 'Confirmer la déconnexion',
    message: 'Êtes-vous sûr de vouloir vous déconnecter ?',
    type: 'info',
    confirmText: 'Déconnexion',
    cancelText: 'Annuler',
    confirmButtonColor: 'primary',
  }),

  deleteAccount: (): ConfirmationOptions => ({
    title: 'Supprimer le compte',
    message: 'Êtes-vous absolument sûr de vouloir supprimer votre compte ? Cette action est irréversible et supprimera définitivement toutes vos données.',
    type: 'error',
    confirmText: 'Supprimer définitivement',
    cancelText: 'Annuler',
    confirmButtonColor: 'error',
    maxWidth: 'md',
  }),

  unsavedChanges: (): ConfirmationOptions => ({
    title: 'Modifications non sauvegardées',
    message: 'Vous avez des modifications non sauvegardées. Êtes-vous sûr de vouloir quitter sans sauvegarder ?',
    type: 'warning',
    confirmText: 'Quitter sans sauvegarder',
    cancelText: 'Continuer l\'édition',
    confirmButtonColor: 'warning',
  }),

  checkout: (): ConfirmationOptions => ({
    title: 'Confirmer la commande',
    message: 'Êtes-vous prêt à procéder au paiement de votre commande ?',
    type: 'info',
    confirmText: 'Procéder au paiement',
    cancelText: 'Continuer les achats',
    confirmButtonColor: 'success',
  }),
}; 